"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _Illustration = _interopRequireDefault(require("../Illustration"));

var _Radio = _interopRequireDefault(require("../form/Radio"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _dimen = require("../../toolkit/dimen");

//
//  src/button/IllustrationButton.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 4/12/19.
//  Copyright © 2019-present ContextLogic Inc. All rights reserved.
//

/* Lego Components */

/* Lego Toolkit */
var DEFAULT_ILLUSTRATION_ALIGNMENT = "bottom";
var propDoc = {
  illustration: {
    required: false,
    type: "?IllustrationName",
    description: "Name of the illustration to display. Can find" + " illustrations in the `toolkit/illustrations.tsx` file"
  },
  illustrationAlignment: {
    required: false,
    type: "\"center\" | \"top\" | \"bottom\"",
    defaultValue: "".concat(DEFAULT_ILLUSTRATION_ALIGNMENT),
    description: "where to align the illustration on the button"
  },
  includeRadioButton: {
    required: false,
    type: "?boolean",
    defaultValue: "false",
    description: "whether to add a radio button to the button"
  },
  selected: {
    required: false,
    type: "?boolean",
    defaultValue: "false",
    description: "indicates that the button is in selected mode"
  },
  onClick: {
    required: true,
    type: "() => void",
    description: "click handler"
  }
};
var demoRender = "\n<IllustrationButton\nillustration=\"productBoostHeader\"\nillustrationAlignment=\"bottom\"\nincludeRadioButton={true}\nselected={true}\nonClick={() => {}}\n>\n  ProductBoost Credits\n</IllustrationButton>\n";

var IllustrationButton = function IllustrationButton(props) {
  var className = props.className,
      style = props.style,
      children = props.children,
      onClick = props.onClick,
      illustration = props.illustration,
      includeRadioButton = props.includeRadioButton,
      selected = props.selected;
  var styles = useStylesheet(props);

  var _useDimenStore = (0, _dimen.useDimenStore)(),
      isSmallScreen = _useDimenStore.isSmallScreen;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, className, style),
    onClick: onClick
  }, includeRadioButton && /*#__PURE__*/_react["default"].createElement(_Radio["default"], {
    className: (0, _styling.css)(styles.radio),
    checked: selected == true
  }), !isSmallScreen && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.content)
  }, children), /*#__PURE__*/_react["default"].createElement(_Illustration["default"], {
    className: (0, _styling.css)(styles.illustration),
    name: illustration,
    alt: "illustration"
  }));
};

IllustrationButton.propDoc = propDoc;
IllustrationButton.demoRender = demoRender;

var _default = (0, _mobxReact.observer)(IllustrationButton);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var selected = props.selected,
      illustrationAlignment = props.illustrationAlignment;

  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      primaryLight = _useTheming$theme.primaryLight,
      primary = _useTheming$theme.primary,
      info = _useTheming$theme.info,
      textBlack = _useTheming$theme.textBlack,
      surfaceLightest = _useTheming$theme.surfaceLightest,
      fonts = _useTheming.fonts;

  var illustrationAlignSelf = undefined;

  switch (illustrationAlignment) {
    case "top":
      illustrationAlignSelf = "flex-start";

    case "bottom":
      illustrationAlignSelf = "flex-end";

    default:
      illustrationAlignSelf = "center";
  }

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer",
        borderRadius: 4,
        padding: "0px 14px",
        transition: "all 0.3s linear",
        color: selected ? primary : textBlack,
        overflow: "hidden",
        border: "solid 1px ".concat(selected ? primary : info),
        backgroundColor: surfaceLightest,
        ":hover": {
          color: primary,
          border: "solid 1px ".concat(primary),
          backgroundColor: primaryLight
        }
      },
      radio: {
        marginRight: 8
      },
      illustration: {
        width: 56,
        alignSelf: illustrationAlignSelf
      },
      content: {
        fontSize: 16,
        fontFamily: fonts.bold,
        lineHeight: 1.5,
        padding: "16px 25px 16px 0px"
      }
    });
  }, [selected, illustrationAlignSelf, primaryLight, primary, info, textBlack, surfaceLightest, fonts.bold]);
};